import * as React from "react";
import { ChakraProvider, theme } from "@chakra-ui/react";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Work from "./components/WorkPages/Work";
import "./styles/global.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import customTheme from "./styles/theme";
import About from "./components/About";
import Kiwi from "./components/UIUXPages/Kiwi";
import Interfaces from "./components/UIUXPages/Interfaces";
import Sakura from "./components/UIUXPages/Sakura";
import ContactBar from "./components/ContactBar";
import Resume from "./components/Resume";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Main from "./components/Main";
import WorkPage from "./components/WorkPages/WorkPage";
import Art from "./components/AnimationPages/Art";
import Artwork from "./components/Artwork";

export const App = () => (
  <ChakraProvider theme={customTheme}>
    <BrowserRouter>
      <Navbar />

      {/* <ContactBar /> */}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/about" element={<About />} />
        <Route path="/mywork" element={<WorkPage />} />
        <Route path="/animation" element={<Art />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/kiwi" element={<Kiwi />} />
        <Route path="/interfaces" element={<Interfaces />} />
        <Route path="/sakura" element={<Sakura />} />
        <Route path="/art" element={<Artwork />} />
      </Routes>
    </BrowserRouter>
  </ChakraProvider>
);
